<template lang="pug">
  #live.page
      Pagination(:page="page" :total="total" :perPage="perPage" @click="pageHandler")

      .level.is-mobile
          .level-right
              a.level-item(@click="showMatchesText=!showMatchesText")
                  span.tag.is-pulled-right.is-info.is-unselectable Processing: {{ processing.length }}
              .level-item {{ paginationDesc }}
      .notification(v-if="showMatchesText")
          .content
              p(v-html="noMatchesText")
      template(v-if="matches.length !== 0")
        Match(v-for="match in matchesPerPage" :match="match" :source="source" :key="`${match._id}${match.updated}`")

      Pagination(:page="page" :total="total" :perPage="perPage" @click="pageHandler")
      .level.is-mobile
        .level-left
          .level-item(@click="changeView")
            a.tag.is-medium(v-show="!processingView")
              span.icon
                i.fas.fa-window-minimize
            a.tag.is-medium(v-show="processingView")
              span.icon
                i.fas.fa-window-maximize
        .level-left
          .level-item.tags.has-addons
            .tag.is-medium(:class="{'is-dark': sort.type === 'time'}" @click="setSort('time')")
              span(v-show="sort.type === 'time'" v-html="sort.order === 'asc' ? '↑' : '↓'" :class="{'has-text-success': sort.order === 'asc', 'has-text-danger': sort.order === 'desc'}")
              span Time
            .tag.is-medium(:class="{'is-dark': sort.type === 'stats'}" @click="setSort('stats')")
              span(v-show="sort.type === 'stats'" v-html="sort.order === 'asc' ? '↑' : '↓'" :class="{'has-text-success': sort.order === 'asc', 'has-text-danger': sort.order === 'desc'}")
              span Stats
      component(
        v-bind:is="match.mini ? 'MatchMini' : 'Match'"
        v-for="match in processing"
        :match="match"
        :source="source"
        :active="processingId"
        :key="`${match._id}_proc`"
        @view="toggleMatchView(match._id)"
      )
</template>

<script>
import moment from "moment";

import Pagination from "@/components/Pagination";
import Match from "@/components/Match";
import MatchMini from "@/components/MatchMini";

export default {
  name: "live",
  components: {
    Pagination,
    MatchMini,
    Match
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      sort: {
        type: "time",
        order: "asc"
      },
      processingView: true,
      showMatchesText: false
    };
  },
  methods: {
    toggleMatchView(id) {
      this.$store.commit("toggleMatchView", { id });
      const allOpen = this.processing.every(({ mini }) => mini === false);
      const allClose = this.processing.every(({ mini }) => mini === true);
      if (allOpen) this.processingView = false;
      if (allClose) this.processingView = true;
    },
    changeView() {
      this.processingView = !this.processingView;
      this.$store.commit("toggleMatchView", { mini: this.processingView });
    },
    pageHandler(page) {
      this.$router.push({
        name: "Live",
        params: {
          page
        }
      });
    },
    setSort(type) {
      if (type === this.sort.type)
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      else this.sort.type = type;
    }
  },
  watch: {
    $route(r) {
      this.page = parseInt(r.params.page);
    }
  },
  computed: {
    processing() {
      const m = this.matches;
      const active = this.$store.state.live.active.map(row => {
        // eslint-disable-next-line fp/no-mutation
        row.hasSignal = !!m.find(({ _id }) => _id === row._id);
        return row;
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties,fp/no-mutating-methods,complexity
      return active.sort((a, b) => {
        const itemA =
          this.sort.type === "time"
            ? a.time
            : parseInt(a.home.statistic.level.live) +
              parseInt(a.away.statistic.level.live);
        const itemB =
          this.sort.type === "time"
            ? b.time
            : parseInt(b.home.statistic.level.live) +
              parseInt(b.away.statistic.level.live);
        if (itemA === itemB) return 0;
        return this.sort.order === "asc"
          ? itemA > itemB
            ? 1
            : -1
          : itemA > itemB
          ? -1
          : 1;
      });
    },
    processingId() {
      return this.$store.state.live.processingId;
    },
    source() {
      return this.$store.getters.getLiveSource;
    },
    filterCategory() {
      return this.$store.getters.filterCategory(this.$route);
    },
    matches() {
      let matches = this.$store.getters.activeMatches;
      let timeLevel = this.$store.state.filters.live.timeFilters.find(
        f => f.status
      ).level;
      return matches.filter(m =>
        timeLevel
          ? m.timeLevel.hasOwnProperty(this.filterCategory)
            ? m.timeLevel[this.filterCategory] === timeLevel
            : false
          : true
      );
    },
    total() {
      return this.matches.length;
    },
    matchesPerPage() {
      const start = (this.page - 1) * this.perPage;
      return this.matches.slice(start, start + this.perPage);
    },
    paginationDesc() {
      const pagesCount = Math.ceil(this.total / this.perPage);
      if (!pagesCount) return;

      const start = (this.page - 1) * this.perPage;
      const total = this.matches.length;
      let end = start + this.perPage;
      if (end > total) end = total;

      return `Showing ${start}-${end} of ${total} matches`;
    },
    noMatchesText() {
      const stat = this.$store.state.live.stat;
      const min = moment(stat.time.min).calendar();
      const max = moment(stat.time.max).calendar();
      const near = moment(stat.time.near).calendar();

      const matchesTime = stat.count.left
        ? `Matches will be held from <span class="tag is-info">${min}</span> to <span class="tag is-info">${max}</span>, nearest at <span class="tag is-info">${near}</span> .<br>`
        : "";

      return `We have <span class="tag is-info">${stat.count.all}</span> football matches in the database. <span class="tag is-info">${stat.count.left}</span> matches left<br>
${matchesTime}
Active matches will be shown when they match the filter conditions.`;
    }
  },
  mounted() {
    this.page = parseInt(this.$route.params.page);
  },
  beforeDestroy() {
    this.$store.dispatch("closeFilters", true);
  }
};
</script>

<style lang="scss" scoped>
#live {
  .source-link {
    top: -5rem;
    padding: 1rem;
    color: $defaultColor;
    text-transform: uppercase;
    font-weight: bold;
    background: transparent;
    transition: all 0.2s linear;

    span:not(.icon) {
      font-size: 1.3rem;
    }

    .wrapper {
      border-bottom: 2px solid $brandColor;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
      color: lighten($brandColor, 20%);
    }
  }

  .tags {
    .tag {
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>
